import {useScreenResize} from 'hooks';
import React from 'react';
import {useTranslation} from 'react-i18next';
import ReactSignatureCanvas from 'react-signature-canvas';
import {device} from 'styled/device';
import {
  ClearSignatureButton,
  SignCanvas,
  SignPlaceholder,
  SignPlaceholderText,
  SignWrapper,
} from './styled';

// const CANVAS_PROPS = {
//   width: 700,
//   height: 305,
// };
const SIGNATURE_PROPS = {
  penColor: '#161643',
  minWidth: 1.5,
  maxWidth: 1.5,
  dotSize: 1,
};

type SignatureCanvasProps = {
  onClear?: () => void;
  onEnable?: () => void;
  hasSignature?: boolean;
  onEnd?: () => void;
  onStart?: () => void;
  className?: string;
  enabled?: boolean;
};

const defaultProps: SignatureCanvasProps = {
  onEnd: () => {},
  onEnable: () => {},
  onStart: () => {},
  onClear: () => {},
  hasSignature: false,
  className: '',
  enabled: false,
};

const SignatureCanvas = React.forwardRef<ReactSignatureCanvas, SignatureCanvasProps>(
  ({onClear, hasSignature, onEnd, onStart, onEnable, className, enabled}, ref) => {
    const {t} = useTranslation();
    const {isMatch: isMobile} = useScreenResize(device.tablet);
    const CANVAS_DESKTOP_PROPS = {
      width: window.innerHeight < 600 ? 319 : 646,
      height: window.innerHeight < 600 ? 182 : 302,
    };
    const CANVAS_PROPS = {
      width: isMobile ? 319 : CANVAS_DESKTOP_PROPS.width,
      height: isMobile ? 182 : CANVAS_DESKTOP_PROPS.height,
    };
    const enableSignature = () => {
      if (onEnable) {
        onEnable();
      }
    };

    return (
      <SignWrapper className={className}>
        {!enabled && (
          <SignPlaceholder data-testid="signature-placeholder" onClick={enableSignature}>
            <SignPlaceholderText>{t('tap_here_to_sign')}</SignPlaceholderText>
          </SignPlaceholder>
        )}
        <SignCanvas hidden={!enabled}>
          <ReactSignatureCanvas
            ref={ref}
            data-testid="canvas"
            {...SIGNATURE_PROPS}
            canvasProps={CANVAS_PROPS}
            onEnd={onEnd}
          />
          {hasSignature && (
            <ClearSignatureButton onClick={onClear}>{t('clear')}</ClearSignatureButton>
          )}
        </SignCanvas>
        {/* {enabled && hasSignature && (
          <RepeatSignatureContainer>
            <RepeatButton
              type="button"
              show={Boolean(enabled && hasSignature)}
              onClick={onClear}
            >
              {t('repeat_signature')}
            </RepeatButton>
          </RepeatSignatureContainer>
        )} */}
      </SignWrapper>
    );
  },
);

SignatureCanvas.defaultProps = defaultProps;
export {SignatureCanvas};
